import { render, staticRenderFns } from "./vcDataGrid.vue?vue&type=template&id=48caf632&"
import script from "./vcDataGrid.vue?vue&type=script&lang=js&"
export * from "./vcDataGrid.vue?vue&type=script&lang=js&"
import style0 from "./vcDataGrid.vue?vue&type=style&index=0&id=48caf632&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports